export default "__VITE_ASSET__C5kdUE2G__"